import { useEffect, useMemo, useRef } from "react"
import { TextureLoader, } from "three"
import { useLoader, useThree } from "react-three-fiber"
import { LinearMipmapLinearFilter } from 'three';

export const useTextureLoader = (images) => {
    const textures = useLoader(TextureLoader, images)
    const { gl } = useThree()
    const texturesRef = useRef();

    useEffect(() => {
        return () => {
            if (texturesRef.current) {
                texturesRef.current.forEach(texture => {
          //          console.log ("[useTextureLoader] dispose", texture);
                    texture.dispose();
                })
                texturesRef.current = null; 
            }
        }
    }, [])

    return useMemo(() => {
        texturesRef.current = textures;
        textures.forEach(texture => {
            texture.minFilter = LinearMipmapLinearFilter;
            texture.anisotropy = gl.capabilities.getMaxAnisotropy();
        })

        return texturesRef.current;
    }, [textures, gl.capabilities]);
    
}